import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-1913ac80")

_pushScopeId("data-v-1913ac80")
const _hoisted_1 = {
  key: 0,
  "aria-label": "Progress"
}
const _hoisted_2 = {
  class: "flex rounded-3xl justify-center border-0 relative ",
  role: "list"
}
const _hoisted_3 = { class: "px-4 mx-auto py-2 flex items-center text-md font-medium" }
const _hoisted_4 = { class: "mb-0 flex-shrink-0 w-10 h-10 flex items-center justify-center bg-bp-light rounded-full group-hover:bg-bp-light" }
const _hoisted_5 = { class: "mb-0 flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-bp-light bg-bp-light rounded-full" }
const _hoisted_6 = { class: "text-white" }
const _hoisted_7 = { class: "px-4 mx-auto py-2 flex items-center text-md font-medium" }
const _hoisted_8 = { class: "mb-1 mb-0 flex-shrink-0 w-10 h-10 flex items-center justify-center border-2 border-gray-300 dark:border-gray-500 rounded-full" }
const _hoisted_9 = { class: "text-gray-400 " }
const _hoisted_10 = {
  key: 3,
  "aria-hidden": "true",
  class: "block absolute top-5 -right-2 h-1/3 w-3"
}
const _hoisted_11 = /*#__PURE__*/_createVNode("svg", {
  class: "h-full w-2 text-gray-300 dark:text-gray-500",
  fill: "none",
  preserveAspectRatio: "none",
  viewBox: "0 0 22 80"
}, [
  /*#__PURE__*/_createVNode("path", {
    d: "M0 -2L20 40L0 82",
    stroke: "currentcolor",
    "stroke-linejoin": "round",
    "vector-effect": "non-scaling-stroke"
  })
], -1)
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_CheckIcon = _resolveComponent("CheckIcon")

  return ($props.steps && $props.steps.length > 0)
    ? (_openBlock(), _createBlock("nav", _hoisted_1, [
        _createVNode("ol", _hoisted_2, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList($props.steps, (step, stepIdx) => {
            return (_openBlock(), _createBlock("li", {
              key: step.name,
              class: "relative flex "
            }, [
              (step.status === 'completed')
                ? (_openBlock(), _createBlock("a", {
                    key: 0,
                    onClick: ($event: any) => ($setup.updateStep(step)),
                    class: "cursor-pointer group flex items-center w-full"
                  }, [
                    _createVNode("span", _hoisted_3, [
                      _createVNode("span", _hoisted_4, [
                        _createVNode(_component_CheckIcon, {
                          "aria-hidden": "true",
                          class: "w-6 h-6 text-white"
                        })
                      ])
                    ])
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (step.status === 'current')
                ? (_openBlock(), _createBlock("a", {
                    key: 1,
                    onClick: ($event: any) => ($setup.updateStep(step)),
                    "aria-current": "step",
                    class: "cursor-pointer px-4 mx-auto py-2 flex items-center text-md font-medium"
                  }, [
                    _createVNode("span", _hoisted_5, [
                      _createVNode("span", _hoisted_6, _toDisplayString(step.id), 1)
                    ])
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              (step.status === 'upcoming')
                ? (_openBlock(), _createBlock("a", {
                    key: 2,
                    onClick: ($event: any) => ($setup.updateStep(step, true)),
                    class: "cursor-pointer group mx-auto flex items-center"
                  }, [
                    _createVNode("span", _hoisted_7, [
                      _createVNode("span", _hoisted_8, [
                        _createVNode("span", _hoisted_9, _toDisplayString(step.id), 1)
                      ])
                    ])
                  ], 8, ["onClick"]))
                : _createCommentVNode("", true),
              ((stepIdx !== $props.steps.length - 1))
                ? (_openBlock(), _createBlock("div", _hoisted_10, [
                    _hoisted_11
                  ]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
})